module.exports = __webpack_public_path__ + "static/favicon.0fba2671.ico";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/img/favicon.ico
// module id = 586
// module chunks = 114276838955818